import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ContractPerformApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'contractPerform'
  }

}